module.exports = __webpack_public_path__ + "b3009ebd2e3694dc37d9b4a4b082f082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-24.jpg
// module id = 1165
// module chunks = 0